import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
import { useActiveOrganization } from '@shared/context/ActiveOrganizationContext';
export const useCategories = () => {
    const queryClient = useQueryClient();
    const { activeOrganizationId, isLoadingOrganizations } = useActiveOrganization();
    const orgQueryReady = Boolean(activeOrganizationId) && !isLoadingOrganizations;
    const categoriesQuery = useQuery({
        queryKey: ['categories', activeOrganizationId],
        enabled: orgQueryReady,
        queryFn: async () => {
            const { data } = await apiClient.get('/categories');
            return data;
        },
    });
    const createCategory = useMutation({
        mutationFn: async (dto) => {
            const { data } = await apiClient.post('/categories', dto);
            return data;
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['categories', activeOrganizationId] });
            }
        },
    });
    const updateCategory = useMutation({
        mutationFn: async ({ id, dto }) => {
            const { data } = await apiClient.patch(`/categories/${id}`, dto);
            return data;
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['categories', activeOrganizationId] });
            }
        },
    });
    const deleteCategory = useMutation({
        mutationFn: async (id) => {
            await apiClient.delete(`/categories/${id}`);
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['categories', activeOrganizationId] });
            }
        },
    });
    const reorderCategories = useMutation({
        mutationFn: async (categoryIds) => {
            await apiClient.post('/categories/reorder', { categoryIds });
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['categories', activeOrganizationId] });
            }
        },
    });
    return {
        ...categoriesQuery,
        categories: categoriesQuery.data ?? [],
        createCategory,
        updateCategory,
        deleteCategory,
        reorderCategories,
    };
};
